import { render } from "./userRoleList.vue?vue&type=template&id=785068e4&scoped=true"
import script from "./userRoleList.vue?vue&type=script&lang=js"
export * from "./userRoleList.vue?vue&type=script&lang=js"

import "./userRoleList.vue?vue&type=style&index=0&id=785068e4&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-785068e4"]])

export default __exports__